import React from 'react';
import * as t from 'io-ts';
import { observer } from 'mobx-react-lite';
import {
    ActiveLabel,
    CampaignName,
    ContentContainer,
    TrashIconWrapper,
    ImageContainer,
    ActiveLabelSmall,
} from './LiveNotificationListItem.style';
import { Checkbox } from 'src/components/Checkbox/Checkbox';
import { Button } from 'src/domains/layouts/shared/buttons/Button';
import {
    ListItem,
    ActionsWrapper,
    ButtonsWrapper,
    CheckboxWrapper,
} from 'src/domains/layouts/shared/cms/list/List.style';
import { MoveUpDown } from 'src/domains/layouts/shared/moreActions/MoveUpDown';
import { LiveNotificationsState } from 'src/AppState/LiveNotificationsState/LiveNotificationsState';

interface LiveNotificationPropsType {
    liveNotificationsState: LiveNotificationsState;
    id: number;
}

const NotificationIdsIO = t.interface({
    idsList: t.array(t.number),
});

export type LandingPageDetailsType = t.TypeOf<typeof NotificationIdsIO>;

export const LiveNotificationListItem = observer(({ liveNotificationsState, id }: LiveNotificationPropsType) => {
    const { liveNotificationsSorted } = liveNotificationsState;
    const state = liveNotificationsState.items.get(id);
    const displayOrderNumbers = liveNotificationsSorted.map((listItem) => listItem.display_order);
    const lowestDisplayNumber = Math.min(...displayOrderNumbers);
    const highestDisplayNumber = Math.max(...displayOrderNumbers);
    const isDisabledUp = state.liveNotificationItemData?.display_order === highestDisplayNumber;
    const isDisabledDown = state.liveNotificationItemData?.display_order === lowestDisplayNumber;

    return (
        <ListItem
            isEdited={state.isEdited}
            homepage={false}
            data-test='notification-item'
            boxHeight='138px'
            direction='row'
        >
            <ImageContainer imgSrc={state.liveNotificationItemData?.img_url ?? ''} />
            <ContentContainer>
                <CampaignName data-test='notification-name'>{state.liveNotificationItemData?.title} </CampaignName>

                <div>
                    <CheckboxWrapper>
                        <Checkbox
                            labelSide='right'
                            onChange={state.setActive}
                            isChecked={state.liveNotificationItemData?.is_active ?? false}
                            isDisabled={false}
                        >
                            <ActiveLabel>Published</ActiveLabel>
                        </Checkbox>

                        <Checkbox
                            labelSide='right'
                            onChange={state.setActiveForAllUsersFlag}
                            isChecked={
                                state.liveNotificationItemData === null
                                    ? false
                                    : state.liveNotificationItemData?.is_show_for_all_users &&
                                      !state.allowedIdsListFilled
                            }
                            isDisabled={state.allowedIdsListFilled}
                        >
                            <div>
                                <ActiveLabel>Active for all users</ActiveLabel>
                                <ActiveLabelSmall>(default just for logged in)</ActiveLabelSmall>
                            </div>
                        </Checkbox>
                    </CheckboxWrapper>

                    <ButtonsWrapper>
                        <MoveUpDown
                            moveItemUp={state.moveItemUp}
                            moveItemDown={state.moveItemDown}
                            isDisabledUp={isDisabledUp}
                            isDisabledDown={isDisabledDown}
                        />
                        <ActionsWrapper>
                            <Button
                                version='secondary'
                                size='small'
                                onClick={state.handleEdit}
                            >
                                Edit
                            </Button>
                            <TrashIconWrapper onClick={state.handleDeleteLiveNotification} />
                        </ActionsWrapper>
                    </ButtonsWrapper>
                </div>
            </ContentContainer>
        </ListItem>
    );
});
